import React from 'react';
import {
	MenuList,
	MenuListItem,
	MenuSection,
	MenuSectionHeading,
} from '@atlaskit/navigation-system';
import { useIntl } from '@atlassian/jira-intl';
import { Nav4MenuLinkItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { MENU_ID_PROJECTS_VIEW_ALL_STARRED } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';

import messages from './messages.tsx';

const VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';

type FavoriteItemsType = {
	idSet: Set<string>;
	list: Array<React.JSX.Element>;
	hasItems: boolean;
	hasNextPage: boolean;
};

export type RecentItemsType = {
	list: Array<React.JSX.Element>;
	hasItems: boolean;
};

type StarredSectionWithFocusRestorationProps = {
	favoriteItems: FavoriteItemsType;
	currentItems: Array<{ id: string; label: string }>;
	currentOrder: Array<{ menuId: string; visible: boolean }>;
	projectKey: string;
};

export function StarredSectionWithFocusRestoration(props: StarredSectionWithFocusRestorationProps) {
	const { favoriteItems } = props;
	const { formatMessage } = useIntl();

	return (
		favoriteItems.hasItems && (
			<>
				<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu.ui.jsw-expandable-project.async-content.jsw-boards.starred-section">
					<MenuSection>
						<MenuSectionHeading>{formatMessage(messages.starred)}</MenuSectionHeading>
						<MenuList>{favoriteItems.list}</MenuList>
					</MenuSection>
				</MenuListItem>
				{favoriteItems.hasNextPage && (
					<Nav4MenuLinkItem href={VIEW_ALL_STARRED_HREF} menuId={MENU_ID_PROJECTS_VIEW_ALL_STARRED}>
						{formatMessage(messages.viewAllStarred)}
					</Nav4MenuLinkItem>
				)}
			</>
		)
	);
}
